import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=dfd23f60&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfd23f60')) {
      api.createRecord('dfd23f60', component.options)
    } else {
      api.reload('dfd23f60', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=dfd23f60&", function () {
      api.rerender('dfd23f60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/ChangePassword.vue"
export default component.exports